import component from './CardImage';

export default component;
